// extracted by mini-css-extract-plugin
module.exports = {"PillBadge":"PillBadge_PillBadge__2b0bs","PillBadgeSelected":"PillBadge_PillBadgeSelected__Bk7Cj"};